<template>
	<div class="cascader">
		<el-select v-model="prvObj" value-key="key" @change="changeCode($event,0)" v-if="provinceShow">
			<el-option v-for="item in provinceOptions" :key="item.key" :value="item" :label="item.value"></el-option>
		</el-select>
		<el-select v-model="cityObj" value-key="key" @change="changeCode($event,1)" v-if="cityShow">
			<el-option v-for="item in cityOptions" :key="item.key" :value="item" :label="item.value"></el-option>
		</el-select>
		<el-select v-model="districtObj" value-key="key" @change="changeCode($event,2)" v-if="areaShow">
			<el-option v-for="item in areaOptions" :key="item.key" :value="item" :label="item.value"></el-option>
		</el-select>
	</div>
</template>

<script setup>
	import { ref,watch,onMounted } from "vue";
	import { getareainfo } from '@/api/common';
	
	const prvObj = ref('');
	const cityObj = ref('');
	const districtObj = ref('');
	const provinceShow = ref(false);
	const cityShow = ref(false);
	const areaShow = ref(false);
	const provinceOptions = ref();
	const cityOptions = ref();
	const areaOptions = ref();
	const props = defineProps({
		areaData: {
			type:Object,
			default:() => {
				return {
					prvId: '',
					cityId: '',
					districtId: ''
				}
			}
		}
	});
	const emit = defineEmits(['prvChange', 'cityChange', 'districtChange']);
	
	watch(props.areaData, (newValue) => {
		prvObj.value = newValue[0];
		cityObj.value = newValue[1];
		districtObj.value = newValue[2];
		if (parseInt(cityObj.value.key) !== 0) {
			fetareaF('city',prvObj.value.key)
		}
		if (parseInt(districtObj.value.key) !== 0) {
			fetareaF('area',cityObj.value.key)
		}
	});
	
	const fetareaF = (key,val) => {
		const id = val != undefined ? parseInt(val) : 0;
		getareainfo(id).then((res) => {
			const arr = Object.values(res.data);
			switch(key)
			{
				case 'city':
					cityOptions.value = arr.map(item => ({ key: item.id, value: item.name }));
					cityShow.value = true
					break;
				case 'area':
					areaOptions.value = arr.map(item => ({ key: item.id, value: item.name }));
					areaShow.value = true
					break;
				default:
				    provinceOptions.value = arr.map(item => ({ key: item.id, value: item.name }));
					provinceShow.value = true
				    break;
			}
		})
	};
	const changeCode = (data,type) =>{
		if (type === 0) {
			cityObj.value = '';
			districtObj.value = '';
			fetareaF('city',data.key)
			emit('prvChange', data);
		}
		if (type === 1) {
			districtObj.value = '';
			fetareaF('area',data.key)
			emit('cityChange', data);
		}
		if (type === 2) {
			emit('districtChange', data);
		}
	};
	
	
	onMounted(() => {
		fetareaF()
	});
</script>

<style>
</style>